import { Container, Row, Col, Navbar, Nav } from "react-bootstrap";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./Header.css";

import RotatingToggler from "./RotatingToggler";
import { useLocation } from "react-router-dom";
import { useCartWishlist } from "../context/CartWishlistContext";

export default function Header({
  handleShowOffcanvas,
  handleShowWishlistModal,
  handleShowOffcanvasSearch,
  handleNavigateToLogin,
  homeRef,
  productsRef,
  bundlesRef,
  blogsRef,
  wishListCounter,
  cartListCounter,
}) {
  const location = useLocation();

  const handleScrollLink = (e, targetId, targetRef) => {
    e.preventDefault();

    if (location.pathname === "/") {
      // Already home → smooth scroll
      targetRef?.current?.scrollIntoView({ behavior: "smooth" });
    } else {
      // Hard reload with hash
      window.location.href = `/#${targetId}`;
    }
  };

  // const handleScrollLink = (e, elem) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   scrollToSection(elem);
  // };

  return (
    <>
      {/* Top Green Bar */}
      <div
        className="py-1 text-white text-center top-bar-display"
        style={{ backgroundColor: "#4BB509" }}
        ref={homeRef}
      >
        Aura Skin Premium – Redefining beauty with the pure luxury of
        Korean skincare.
      </div>

      {/* Middle Bar */}
      <div className="border-bottom bg-white middle-bar-display">
        <Container>
          <Row className="py-2 align-items-center text-center text-md-start">
            <Col md={12} className="mb-2 mb-md-0">
              <span className="me-3">
                <i className="bi bi-facebook"></i> 300k Followers
              </span>
              <span style={{ marginRight: "150px" }}>
                <i className="bi bi-instagram"></i> 100k Followers
              </span>
              <span className="">
                Bundle the Beauty – Unlock up to 10% Off with Aura Skin Premium.
              </span>
            </Col>
            {/* <Col
              md={6}
              className="d-flex justify-content-center justify-content-md-end flex-wrap"
            >
              <span className="me-2">
                Bundle the Beauty – Unlock up to 10% Off with Aura Skin Premium.
              </span>
              
            </Col> */}
          </Row>
        </Container>
      </div>

      <header className="sticky-header">
        {/* Bottom Navbar */}
        <Navbar bg="white" expand="lg" className="shadow-sm">
          <Container>
            <Navbar.Brand href="/">
              <img
                src="/img/logo/logo.png"
                alt="logo"
                // style={{ height: "50px" }}
                className="logo-tl"
              />
            </Navbar.Brand>
            {/* <Navbar.Toggle aria-controls="main-navbar" /> */}
            <RotatingToggler />

            <Navbar.Collapse id="main-navbar">
              <Nav className="mx-auto">
                <Nav.Link
                  href="/"
                  onClick={(e) => handleScrollLink(e, "home", homeRef)}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  href="/products"
                  onClick={(e) => handleScrollLink(e, "products", productsRef)}
                >
                  All Products
                </Nav.Link>
                <Nav.Link
                  href="/bundles"
                  onClick={(e) => handleScrollLink(e, "bundles", bundlesRef)}
                >
                  Bundles
                </Nav.Link>
                <Nav.Link
                  href="/blogs"
                  onClick={(e) => handleScrollLink(e, "blogs", blogsRef)}
                >
                  Blogs
                </Nav.Link>
              </Nav>
              {/* <Nav className="mx-auto">
                <Nav.Link
                  href="/"
                  onClick={(e) => handleScrollLink(e, homeRef)}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  href="/products"
                  onClick={(e) => handleScrollLink(e, productsRef)}
                >
                  All Products
                </Nav.Link>
                <Nav.Link
                  href="/bundles"
                  onClick={(e) => handleScrollLink(e, bundlesRef)}
                >
                  Herbal Bundles
                </Nav.Link>
                <Nav.Link
                  href="/order"
                  onClick={(e) => handleScrollLink(e, blogsRef)}
                >
                  Blogs
                </Nav.Link>
              </Nav> */}
              <IconBar
                handleShowOffcanvas={handleShowOffcanvas}
                handleShowWishlistModal={handleShowWishlistModal}
                handleShowOffcanvasSearch={handleShowOffcanvasSearch}
                handleNavigateToLogin={handleNavigateToLogin}
                wishListCounter={wishListCounter}
                cartListCounter={cartListCounter}
              />
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Sticky styles */}
        <style>{`
        .sticky-header {
          position: sticky;
          top: 0;
          z-index: 1050;
          background: #fff;
        }
      `}</style>
      </header>
    </>
  );
}

function IconBar({
  handleShowWishlistModal,
  handleShowOffcanvas,
  handleShowOffcanvasSearch,
  handleNavigateToLogin,
  // wishListCounter = 0,
  // cartListCounter = 0,
}) {
  // console.log(cartListCounter);

  const { cartListCounter, wishListCounter } = useCartWishlist();

  const icons = [
    {
      icon: "bi-search",
      size: 20,
      text: "Search",
      onClick: () => handleShowOffcanvasSearch(),
    },
    {
      icon: "bi-person",
      size: 25,
      text: "Account",
      onClick: () => handleNavigateToLogin(),
    },
    {
      icon: "bi-heart",
      size: 21,
      text: "Wishlist",
      onClick: () => handleShowWishlistModal(),
      badge: wishListCounter || 0,
    },
    {
      icon: "bi-bag",
      size: 20,
      text: "Cart",
      onClick: () => handleShowOffcanvas(),
      badge: cartListCounter || 0,
    },
  ];

  return (
    <div className="d-flex align-items-center gap-3">
      {icons.map((item, idx) => (
        <OverlayTrigger
          key={idx}
          placement="bottom"
          overlay={<Tooltip>{item.text}</Tooltip>}
        >
          <div
            style={{ cursor: "pointer", fontSize: `${item.size}px` }}
            onClick={item.onClick}
            className="position-relative"
          >
            <i className={`bi ${item.icon}`}></i>
            {typeof item.badge === "number" && item.badge > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{
                  fontSize: "0.65rem",
                  minWidth: "18px",
                  height: "18px",
                  padding: "2px 6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {item.badge}
              </span>
            )}
          </div>
        </OverlayTrigger>
      ))}
    </div>
  );
}
